export const QUERY_KEY_AUTHORITIES = 'authorities';
export const QUERY_KEY_AUTHORITY_SOURCE = 'authority-source';
